import React, { useState } from 'react';
import { Link } from 'react-scroll';
import {
    FaAndroid,
    FaHtml5,
    FaGamepad,
    FaPhotoVideo,
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import CategoryProjectsModal from './CategoryProjectsModal';

const services = [
    {
        name: 'Desarrollo web',
        desciption: 'Desarrollamos todo tipo de sitos web. Coorporativos, landing page, e-learnings, y mucho más.',
        icon: (
            <div className="text-mainBlue text-[25px] w-9 h-9 mb-[42px] flex flex-col items-center justify-center">
                <FaHtml5 />
            </div>
        ),
        categoryKey: 'Desarrollos web',
    },
    {
        name: 'Desarrollo móvil',
        desciption: 'Desarrollamos aplicaciones híbridas, funcionales en los 2 sistemas operativos móviles más grandes del mercado.',
        icon: (
            <div className="text-mainBlue text-[25px] w-9 h-9 mb-[42px] flex flex-col items-center justify-center">
                <FaAndroid />
            </div>
        ),
        categoryKey: 'Desarrollos moviles',
    },
    {
        name: 'Videojuegos',
        desciption: 'Tanto videojuegos web como móviles, con diversos tipos de interacciones y captura de datos.',
        icon: (
            <div className="text-mainBlue text-[25px] w-9 h-9 mb-[42px] flex flex-col items-center justify-center">
                <FaGamepad />
            </div>
        ),
        categoryKey: 'Videojuegos',
    },
    {
        name: 'Juegos con IA',
        desciption: 'Disfruta experiencias interactivas impulsadas por inteligencia artificial, donde cada decisión del usuario cambia el rumbo de la historia.',
        icon: (
            <div className="text-mainBlue text-[25px] w-9 h-9 mb-[42px] flex flex-col items-center justify-center">
                <FaPhotoVideo />
            </div>
        ),
        categoryKey: 'Juegos de IA',
    },
];

const Services = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const handleViewProjects = (categoryKey) => {
        setSelectedCategory(categoryKey);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedCategory(null);
    };

    return (
        <section id="services" className="section">
            <div className="container mx-auto">
                <div className="flex flex-col lg:flex-row">
                    {/* TEXT */}
                    <motion.div
                        variants={fadeIn('right', 0.3)}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.3 }}
                        className="flex-1 lg:bg-services lg:bg-bottom bg-no-repeat bg-contain mb-12 lg:mb-0"
                    >
                        <h2 className="h2 text-secondBlue mb-6">¿Qué hacemos ?</h2>
                        <h3 className="text-mainBlue text-[20px] lg:text-[25px] max-w-[455px] mb-16">
                            Contamos con un {' '}
                            <strong className="text-mainYellow">
                                gran equipo de TyD
                            </strong>
                            {' '}
                            para desarrollar los siguientes tipos de proyectos :
                        </h3>
                        <Link
                            to="work"
                            smooth={true}
                            spy={true}
                            className="cursor-pointer btn btn-sm"
                        >
                            Nuestro portafolio
                        </Link>
                    </motion.div>

                    {/* SERVICES */}
                    <motion.div
                        variants={fadeIn('left', 0.5)}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: false, amount: 0.3 }}
                        className="flex-1"
                    >
                        <div>
                            {services.map((service, index) => (
                                <div
                                    key={index}
                                    className="border-b border-mainYellow/100 h-[146px] mb-[38px] flex"
                                >
                                    <div className="max-w-[476px] mr-5">
                                        <h4 className="text-secondBlue text-[20px] tracking-wider font-primary font-semibold mb-6">
                                            {service.name}
                                        </h4>
                                        <p className="text-mainBlue font-secondary leading-tight">
                                            {service.desciption}
                                        </p>
                                    </div>
                                    <div className="flex flex-col flex-1 items-end">
                                        {service.icon}
                                        <button
                                            onClick={() =>
                                                handleViewProjects(service.categoryKey)
                                            }
                                            className="text-secondBlue text-sm text-gradient hover:text-mainYellow transition-colors cursor-pointer"
                                        >
                                            Ver proyectos
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>

                {/* Category Projects Modal */}
                <CategoryProjectsModal
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                    category={selectedCategory}
                />
            </div>
        </section>
    );
};

export default Services;
